import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { AreasSection } from './components/AreasSection';
import { ClinicalApproachSection } from './components/ClinicalApproachSection';
import { ProcessSection } from './components/ProcessSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-sage-200 selection:text-sage-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <ClinicalApproachSection data-id="element-6" />
        <AreasSection data-id="element-7" />
        <ProcessSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <ContactSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}